export type TranslateTimeFn = (
  key: string,
  options?: { value?: number }
) => string;

const formatVolunteerTime = (minutes: number, t: TranslateTimeFn): string => {
  if (minutes === 0) {
    return t("TIME_0_MINUTES");
  }

  if (minutes < 60) {
    return minutes === 1
      ? t("TIME_1_MINUTE")
      : t("TIME_MINUTES", { value: minutes });
  }

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  if (remainingMinutes === 0) {
    return hours === 1 ? t("TIME_1_HOUR") : t("TIME_HOURS", { value: hours });
  }

  const hoursStr =
    hours === 1 ? t("TIME_1_HOUR") : t("TIME_HOURS", { value: hours });
  const minutesStr =
    remainingMinutes === 1
      ? t("TIME_1_MINUTE")
      : t("TIME_MINUTES", { value: remainingMinutes });
  return `${hoursStr} ${minutesStr}`;
};

export { formatVolunteerTime };
